import publicIPUIStore from './publicIPUIStore.js';
import publicIPDataStore from './publicIPDataStore.js';

export default {
  modules: {
    ui: publicIPUIStore,
    data: publicIPDataStore,
  },
};
